import type { ImageReference } from '@tsagko/label-contracts'

/**
 * Canonical key for an `ImageReference`, used to look up resolved buffers in
 * the `Map<string, ImageBuffer>` passed to `generateZpl` / `buildCommands`.
 *
 * The naive `JSON.stringify(ref)` is sensitive to key insertion order, so
 * two semantically identical refs like `{ kind: 'url', url: 'x' }` and
 * `{ url: 'x', kind: 'url' }` would otherwise produce different keys and
 * silently miss a buffer that was inserted under the "wrong" ordering.
 *
 * We serialize with a sorted list of own enumerable keys to eliminate that
 * class of silent-blank-image bug. The helper is also used by
 * `analyzeTemplateRequirements` for image dedup — same risk applies there.
 *
 * Pure: no side effects, deterministic for any (semantically equivalent)
 * ImageReference input.
 */
export function canonicalImageRefKey(ref: ImageReference): string {
  return JSON.stringify(ref, Object.keys(ref).sort())
}
